import gsap from "gsap";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);

function initHeroSequence() {
	// Selecteer alle hero elementen
	const logo = document.querySelector('.logo');
	const heroVideo = document.querySelector('.hero-video-animate');
	const heroTitle = document.querySelector('.hero__title.split-words');
	const heroTextElements = document.querySelectorAll('.hero-text-animate');
	const heroCTAs = document.querySelector('.hero-cta-animate');
	const heroGraphImg = document.querySelector('.hero__graph img');

	// Return als hero elementen niet bestaan (niet op homepage)
	if (!heroTitle) {
		console.log('Hero title not found, skipping hero sequence');
		return;
	}

	// Split de H1 title in woorden
	const splitTitle = new SplitText(heroTitle, {
		type: "words",
		wordsClass: "single-word",
	});

	// Maak de H1 container zichtbaar en zet split-text woorden op onzichtbaar
	gsap.set(heroTitle, { opacity: 1 }); // Override inline CSS voor container
	if (splitTitle.words.length) {
		gsap.set(splitTitle.words, { y: 60, opacity: 0 });
	}

	// Video heeft geen preload/autoplay in de HTML, laden start hier pas
	if (heroVideo) {
		heroVideo.play();
		gsap.to(heroVideo, {
			opacity: 1,
			duration: 0.6,
			ease: "power2.out"
		});
	}

	// Functie om H1 en rest te animeren na Lottie completion
	function animateAfterLottie() {
		const textTimeline = gsap.timeline();

		// H1 split-text animatie (Kodea-style) - sneller en vloeiender
		if (splitTitle.words.length) {
			textTimeline.to(splitTitle.words, {
				opacity: 1,
				y: 0,
				duration: 0.6, // Korter voor snellere overgang
				stagger: 0.06, // Snellere stagger voor vloeiender effect
				ease: "power2.out"
			});
		}

		// Tekst en CTA's als geheel van onder naar boven
		const restElements = [];
		if (heroTextElements.length) restElements.push(...heroTextElements);
		if (heroCTAs) restElements.push(heroCTAs);
		
		if (restElements.length) {
			textTimeline.to(restElements, {
				opacity: 1,
				y: 0,
				duration: 0.5, // Korter voor snellere flow
				stagger: 0.1, // Snellere stagger
				ease: "power2.out"
			}, splitTitle.words.length ? "-=0.4" : "0"); // Meer overlap voor vloeiender overgang
		}

		// Hero graph img (E) animatie gelijktijdig met content
		if (heroGraphImg) {
			textTimeline.to(heroGraphImg, {
				opacity: 1, // Van 10% naar 100% (originele volledige wittheid)
				duration: 15, // 10 seconden langzame fade-in
				ease: "power1.inOut"
			}, 0); // Start tegelijk met H1 (tijd 0 van timeline)
		}
	}

	// Start H1 animatie na 500ms
	setTimeout(() => {
		console.log('Starting text animations after 500ms');
		animateAfterLottie();
	}, 500);
}

function initSplitText() {
	// Select all other elements with the .split-words class (not hero)
	const splitWordElements = document.querySelectorAll(".split-words:not(.hero__title)");

	gsap.set(splitWordElements, { opacity: 1 });

	splitWordElements.forEach((element) => {
		const splitTextInstance = new SplitText(element, {
			type: "words",
			wordsClass: "single-word",
		});

		const words = splitTextInstance.words;

		// Set initial state for the animation
		gsap.set(words, { y: 80, opacity: 0 });

		// Create animation that runs immediately
		gsap.to(words, {
			y: 0,
			opacity: 1,
			duration: 0.6,
			stagger: 0.1,
			ease: "power2.out",
		});
	});
}

window.addEventListener("load", () => {
	// Start hero sequence
	initHeroSequence();
	
	// Initialize other split text animations
	initSplitText();
});